// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Types$OrcaPaymentPage from "./Types.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as Sentry$OrcaPaymentPage from "../hyper-log-catcher/Sentry.bs.js";
import * as Window$OrcaPaymentPage from "../Window.bs.js";
import * as APIUtils$OrcaPaymentPage from "../Utilities/APIHelpers/APIUtils.bs.js";
import * as Elements$OrcaPaymentPage from "./Elements.bs.js";
import * as ErrorUtils$OrcaPaymentPage from "../Utilities/ErrorUtils.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "../Utilities/ApiEndpoint.bs.js";
import * as HyperLogger$OrcaPaymentPage from "../hyper-log-catcher/HyperLogger.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as PaymentSession$OrcaPaymentPage from "./PaymentSession.bs.js";
import * as ApplePayHelpers$OrcaPaymentPage from "../Utilities/ApplePayHelpers.bs.js";
import * as RecoilAtomTypes$OrcaPaymentPage from "../Types/RecoilAtomTypes.bs.js";
import * as EventListenerManager$OrcaPaymentPage from "../Utilities/EventListenerManager.bs.js";
import * as AuthenticationSession$OrcaPaymentPage from "./AuthenticationSession.bs.js";
import * as UpdateIntentHelpersNew$OrcaPaymentPage from "./UpdateIntentHelpersNew.bs.js";
import * as PaymentMethodsManagementElements$OrcaPaymentPage from "./PaymentMethodsManagementElements.bs.js";

function checkAndAppend(selector, child) {
  if (Caml_option.nullable_to_opt(document.querySelector(selector)) === undefined) {
    document.body.appendChild(child);
    return ;
  }
  
}

if (document.querySelectorAll("script[src=\"" + sentryScriptUrl + "\"]").length === 0 && typeof sentryScriptUrl !== "undefined" && sentryScriptUrl !== "") {
  try {
    var script = document.createElement("script");
    script.src = sentryScriptUrl;
    script.onerror = (function (err) {
        console.error("ERROR DURING LOADING Sentry on HyperLoader", err);
      });
    script.onload = (function () {
        Sentry$OrcaPaymentPage.initiateSentryJs(sentryDSN);
      });
    window.onload = (function () {
        document.body.appendChild(script);
      });
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    console.error("Sentry load exited", e);
  }
}

function preloadFile(type_, hrefOpt) {
  var href = hrefOpt !== undefined ? hrefOpt : "";
  var link = document.createElement("link");
  link.href = href;
  link.as = type_;
  link.rel = "prefetch";
  link.crossorigin = "anonymous";
  checkAndAppend("link[href=\"" + href + "\"]", link);
}

function preloader() {
  preloadFile("script", ApiEndpoint$OrcaPaymentPage.sdkDomainUrl + "/app.js");
  preloadFile("style", ApiEndpoint$OrcaPaymentPage.sdkDomainUrl + "/app.css");
  preloadFile("image", ApiEndpoint$OrcaPaymentPage.sdkDomainUrl + "/icons/orca.svg");
  preloadFile("script", "https://js.braintreegateway.com/web/3.92.1/js/paypal-checkout.min.js");
  preloadFile("script", "https://js.braintreegateway.com/web/3.92.1/js/client.min.js");
}

function handleHyperApplePayMounted($$event) {
  var json = $$event.data;
  var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
  var applePaySessionRef = {
    contents: null
  };
  var componentName = Utils$OrcaPaymentPage.getString(dict, "componentName", "payment");
  if (Core__Option.isSome(dict["hyperApplePayCanMakePayments"])) {
    var msg = Object.fromEntries([
          [
            "applePayCanMakePayments",
            true
          ],
          [
            "componentName",
            componentName
          ]
        ]);
    return Window$OrcaPaymentPage.sendPostMessageJSON($$event.source, msg);
  }
  if (!Core__Option.isSome(dict["hyperApplePayButtonClicked"])) {
    return ;
  }
  var paymentRequest = Core__Option.getOr(dict["paymentRequest"], null);
  var applePayPresent = dict["applePayPresent"];
  var clientSecret = Utils$OrcaPaymentPage.getString(dict, "clientSecret", "");
  var sdkAuthorization = Utils$OrcaPaymentPage.getString(dict, "sdkAuthorization", "");
  var publishableKey = Utils$OrcaPaymentPage.getString(dict, "publishableKey", "");
  var isTaxCalculationEnabled = Utils$OrcaPaymentPage.getBool(dict, "isTaxCalculationEnabled", false);
  var sdkSessionId = Utils$OrcaPaymentPage.getString(dict, "sdkSessionId", "");
  var analyticsMetadata = Utils$OrcaPaymentPage.getJsonFromDict(dict, "analyticsMetadata", null);
  var isSavedMethodsFlow = Utils$OrcaPaymentPage.getBool(dict, "isSavedMethodsFlow", false);
  var logger = HyperLogger$OrcaPaymentPage.make(sdkSessionId, "Loader", clientSecret, publishableKey, analyticsMetadata);
  var callBackFunc = function (payment) {
    var msg = Object.fromEntries([
          [
            "applePayPaymentToken",
            payment.token
          ],
          [
            "applePayBillingContact",
            payment.billingContact
          ],
          [
            "applePayShippingContact",
            payment.shippingContact
          ],
          [
            "componentName",
            componentName
          ],
          [
            "isSavedMethodsFlow",
            isSavedMethodsFlow
          ]
        ]);
    Window$OrcaPaymentPage.sendPostMessageJSON($$event.source, msg);
  };
  var resolvePromise = function (param) {
    var msg = Object.fromEntries([
          [
            "showApplePayButton",
            true
          ],
          [
            "componentName",
            componentName
          ]
        ]);
    Window$OrcaPaymentPage.sendPostMessageJSON($$event.source, msg);
  };
  ApplePayHelpers$OrcaPaymentPage.startApplePaySession(paymentRequest, applePaySessionRef, applePayPresent, logger, callBackFunc, resolvePromise, clientSecret, publishableKey, isTaxCalculationEnabled, Caml_option.some(sdkAuthorization));
}

EventListenerManager$OrcaPaymentPage.addSmartEventListener("message", handleHyperApplePayMounted, "onHyperApplePayMount");

function make(keys, options, analyticsInfo) {
  try {
    var val = Core__JSON.Classify.classify(keys);
    var publishableKey;
    if (typeof val !== "object") {
      publishableKey = "";
    } else {
      switch (val.TAG) {
        case "String" :
            publishableKey = val._0;
            break;
        case "Object" :
            publishableKey = Utils$OrcaPaymentPage.getString(val._0, "publishableKey", "");
            break;
        default:
          publishableKey = "";
      }
    }
    var json = Core__JSON.Classify.classify(keys);
    if (typeof json === "object") {
      switch (json.TAG) {
        case "Object" :
            Utils$OrcaPaymentPage.getString(json._0, "profileId", "");
            break;
        default:
          
      }
    }
    var isPreloadEnabled = Utils$OrcaPaymentPage.getBool(Utils$OrcaPaymentPage.getOptionsDict(options), "isPreloadEnabled", true);
    var isTestMode = Utils$OrcaPaymentPage.getBool(Utils$OrcaPaymentPage.getOptionsDict(options), "isTestMode", false);
    var shouldUseTopRedirection = Utils$OrcaPaymentPage.getBool(Utils$OrcaPaymentPage.getOptionsDict(options), "shouldUseTopRedirection", false);
    var overridenDefaultRedirectionFlags = {
      shouldUseTopRedirection: shouldUseTopRedirection,
      shouldRemoveBeforeUnloadEvents: false
    };
    var redirectionFlags = RecoilAtomTypes$OrcaPaymentPage.decodeRedirectionFlags(Utils$OrcaPaymentPage.getJsonObjectFromDict(Utils$OrcaPaymentPage.getOptionsDict(options), "redirectionFlags"), overridenDefaultRedirectionFlags);
    var isForceInit = Utils$OrcaPaymentPage.getBool(Utils$OrcaPaymentPage.getOptionsDict(options), "isForceInit", false);
    var analyticsMetadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(Utils$OrcaPaymentPage.getDictFromObj(Utils$OrcaPaymentPage.getOptionsDict(options), "analytics"), "metadata");
    if (isPreloadEnabled) {
      preloader();
    }
    var analyticsInfoDict = Core__Option.getOr(Core__Option.flatMap(analyticsInfo, Core__JSON.Decode.object), {});
    var sessionID = Utils$OrcaPaymentPage.getString(analyticsInfoDict, "sessionID", "hyp_" + Utils$OrcaPaymentPage.generateRandomString(8));
    var sdkTimestamp = Utils$OrcaPaymentPage.getString(analyticsInfoDict, "timeStamp", Date.now().toString());
    var logger = HyperLogger$OrcaPaymentPage.make(sessionID, "Loader", undefined, publishableKey, analyticsMetadata);
    var isReadyPromise = new Promise((function (resolve, param) {
            var handleOnReady = function ($$event) {
              var json = $$event.data;
              var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
              if (Utils$OrcaPaymentPage.getBool(dict, "ready", false)) {
                return resolve(Date.now());
              }
              
            };
            EventListenerManager$OrcaPaymentPage.addSmartEventListener("message", handleOnReady, "handleOnReady");
          }));
    if (options !== undefined) {
      var customBackendUrl = Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(Core__JSON.Decode.object(options), (function (x) {
                      return x["customBackendUrl"];
                    })), Core__JSON.Decode.string), "");
      if (customBackendUrl === "") {
        
      } else {
        ApiEndpoint$OrcaPaymentPage.setApiEndPoint(customBackendUrl);
      }
    }
    Sentry$OrcaPaymentPage.sentryLogger(function () {
          logger.setMerchantId(publishableKey);
          logger.setSessionId(sessionID);
          logger.setLogInfo(Window$OrcaPaymentPage.hrefWithoutSearch, "APP_INITIATED", sdkTimestamp, undefined, undefined, undefined, undefined);
        });
    var isSecure = isSecureContext;
    if (!isSecure) {
      ErrorUtils$OrcaPaymentPage.manageErrorWarning("HTTP_NOT_ALLOWED", Window$OrcaPaymentPage.hrefWithoutSearch, logger);
      Js_exn.raiseError("Insecure domain: " + Window$OrcaPaymentPage.hrefWithoutSearch);
    }
    var hyperMethod = window.HyperMethod;
    var exit = 0;
    if ((hyperMethod == null) || isForceInit) {
      exit = 1;
    } else {
      logger.setLogInfo("orca-sdk initiated", "APP_REINITIATED", sdkTimestamp, undefined, undefined, undefined, undefined);
      return hyperMethod;
    }
    if (exit === 1) {
      var loaderTimestamp = Date.now().toString();
      Sentry$OrcaPaymentPage.sentryLogger(function () {
            logger.setLogInfo("loadHyper has been called", "LOADER_CALLED", loaderTimestamp, undefined, undefined, undefined, undefined);
            if (publishableKey === "" || ![
                  "pk_dev_",
                  "pk_snd_",
                  "pk_prd_"
                ].some(function (prefix) {
                    return publishableKey.startsWith(prefix);
                  })) {
              ErrorUtils$OrcaPaymentPage.manageErrorWarning("INVALID_PK", undefined, logger);
            }
            if (document.querySelectorAll("script[src=\"https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js\"]").length !== 0) {
              return ;
            }
            var script = document.createElement("script");
            script.src = "https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js";
            script.onerror = (function (err) {
                console.error("ERROR DURING LOADING APPLE PAY", err);
              });
            document.body.appendChild(script);
          });
      if (document.querySelectorAll("script[src=\"https://pay.google.com/gp/p/js/pay.js\"]").length === 0) {
        var googlePayScript = document.createElement("script");
        googlePayScript.src = "https://pay.google.com/gp/p/js/pay.js";
        googlePayScript.onerror = (function (param) {
            logger.setLogError("ERROR DURING LOADING GOOGLE PAY SCRIPT", "GOOGLE_PAY_SCRIPT", undefined, undefined, undefined, undefined, "GOOGLE_PAY");
          });
        document.body.appendChild(googlePayScript);
        logger.setLogInfo("GooglePay Script Loaded", "GOOGLE_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
      }
      if (document.querySelectorAll("script[src=\"https://img.mpay.samsung.com/gsmpi/sdk/samsungpay_web_sdk.js\"]").length === 0) {
        var samsungPayScript = document.createElement("script");
        samsungPayScript.src = "https://img.mpay.samsung.com/gsmpi/sdk/samsungpay_web_sdk.js";
        samsungPayScript.onerror = (function (param) {
            logger.setLogError("ERROR DURING LOADING SAMSUNG PAY SCRIPT", "SAMSUNG_PAY_SCRIPT", undefined, undefined, undefined, undefined, "SAMSUNG_PAY");
          });
        document.body.appendChild(samsungPayScript);
        samsungPayScript.onload = (function () {
            logger.setLogInfo("SamsungPay Script Loaded", "SAMSUNG_PAY_SCRIPT", undefined, undefined, undefined, undefined, undefined);
          });
      }
      var iframeRef = {
        contents: []
      };
      var clientSecret = {
        contents: ""
      };
      var sdkAuthorization = {
        contents: ""
      };
      var pmSessionId = {
        contents: ""
      };
      var setIframeRef = function (ref) {
        iframeRef.contents.push(ref);
      };
      var isUpdateIntentInProgress = {
        contents: false
      };
      var emptyJsonPromise = Promise.resolve(null);
      var paymentMethodsDataPromise = {
        contents: emptyJsonPromise
      };
      var customerPaymentMethodsDataPromise = {
        contents: emptyJsonPromise
      };
      var sessionTokensDataPromise = {
        contents: emptyJsonPromise
      };
      var retrievePaymentIntentFn = async function (clientSecretOrSdkAuth) {
        var match;
        try {
          var sdkAuthorizationData = Utils$OrcaPaymentPage.getSdkAuthorizationData(clientSecretOrSdkAuth);
          var cs = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorizationData.clientSecret);
          var extractedClientSecret = cs !== undefined ? cs : clientSecretOrSdkAuth;
          match = [
            extractedClientSecret,
            clientSecretOrSdkAuth
          ];
        }
        catch (exn){
          match = [
            clientSecretOrSdkAuth,
            undefined
          ];
        }
        var sdkAuthorizationValue = match[1];
        var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
              publishableKey: publishableKey,
              clientSecret: match[0],
              sdkAuthorization: sdkAuthorizationValue
            }, "RetrievePaymentIntent");
        var onSuccess = function (data) {
          return Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                        "paymentIntent",
                        data
                      ]]);
        };
        var onFailure = function (param) {
          return null;
        };
        return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "RETRIEVE_CALL", logger, onSuccess, onFailure, undefined, undefined, "GET", Caml_option.some(undefined), Caml_option.some(publishableKey), undefined, undefined, Caml_option.some(sdkAuthorizationValue), undefined);
      };
      var confirmPaymentWrapper = function (payload, isOneClick, result, isSdkButtonOpt) {
        var isSdkButton = isSdkButtonOpt !== undefined ? isSdkButtonOpt : false;
        var confirmTimestamp = Date.now();
        var confirmParams = Core__Option.getOr(Core__Option.flatMap(Core__JSON.Decode.object(payload), (function (x) {
                    return x["confirmParams"];
                  })), {});
        var redirect = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(payload), "redirect", "if_required");
        var url = Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(Core__JSON.Decode.object(confirmParams), (function (x) {
                        return x["return_url"];
                      })), Core__JSON.Decode.string), "");
        var cryptoParams = Core__Option.flatMap(Core__JSON.Decode.object(confirmParams), (function (x) {
                return x["crypto"];
              }));
        var postSubmitMessage = function (message) {
          iframeRef.contents.forEach(function (ifR) {
                Window$OrcaPaymentPage.iframePostMessage(ifR, message);
              });
        };
        if (isTestMode) {
          return Promise.resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse("test_mode_bypass", "Confirm Payment called in test mode - API call bypassed"));
        } else {
          return new Promise((function (resolve1, param) {
                        Core__Promise.$$catch(Promise.race([
                                    isReadyPromise,
                                    Utils$OrcaPaymentPage.delay(1500).then(function (param) {
                                          return Promise.resolve(Date.now());
                                        })
                                  ]).then(function (readyTimestamp) {
                                  var handleMessage = function ($$event) {
                                    var json = $$event.data;
                                    var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
                                    var val = dict["submitSuccessful"];
                                    if (val === undefined) {
                                      return ;
                                    }
                                    LoggerUtils$OrcaPaymentPage.logApi("CONFIRM_PAYMENT", undefined, undefined, "Method", undefined, "confirmPayment", val, logger, undefined, undefined, undefined);
                                    var data = Core__Option.getOr(dict["data"], {});
                                    var returnUrl = Core__Option.getOr(Core__Option.flatMap(dict["url"], Core__JSON.Decode.string), url);
                                    if (isOneClick) {
                                      iframeRef.contents.forEach(function (ifR) {
                                            Window$OrcaPaymentPage.iframePostMessage(ifR, Object.fromEntries([[
                                                        "oneClickDoSubmit",
                                                        false
                                                      ]]));
                                          });
                                    }
                                    postSubmitMessage(dict);
                                    var submitSuccessfulValue = Core__Option.getOr(Core__JSON.Decode.bool(val), false);
                                    if (isSdkButton && submitSuccessfulValue || submitSuccessfulValue && redirect === "always") {
                                      return Utils$OrcaPaymentPage.replaceRootHref(returnUrl, redirectionFlags);
                                    } else if (submitSuccessfulValue) {
                                      return resolve1(data);
                                    } else {
                                      return resolve1(json);
                                    }
                                  };
                                  var confirmParamsMessage = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                                            [
                                              "return_url",
                                              url
                                            ],
                                            [
                                              "publishableKey",
                                              publishableKey
                                            ],
                                            [
                                              "redirect",
                                              redirect
                                            ]
                                          ]));
                                  if (cryptoParams !== undefined) {
                                    confirmParamsMessage["crypto"] = cryptoParams;
                                  }
                                  var message = isOneClick ? Object.fromEntries([[
                                            "oneClickDoSubmit",
                                            result
                                          ]]) : Object.fromEntries([
                                          [
                                            "doSubmit",
                                            true
                                          ],
                                          [
                                            "clientSecret",
                                            clientSecret.contents
                                          ],
                                          [
                                            "confirmTimestamp",
                                            confirmTimestamp
                                          ],
                                          [
                                            "readyTimestamp",
                                            readyTimestamp
                                          ],
                                          [
                                            "confirmParams",
                                            confirmParamsMessage
                                          ]
                                        ]);
                                  EventListenerManager$OrcaPaymentPage.addSmartEventListener("message", handleMessage, "onSubmit");
                                  postSubmitMessage(message);
                                  return Promise.resolve(null);
                                }), (function (param) {
                                return Promise.resolve(null);
                              }));
                      }));
        }
      };
      var confirmPayment = function (payload) {
        if (isUpdateIntentInProgress.contents) {
          return Promise.resolve(UpdateIntentHelpersNew$OrcaPaymentPage.confirmBlockedResponse());
        } else {
          return confirmPaymentWrapper(payload, false, true, undefined);
        }
      };
      var confirmOneClickPayment = function (payload, result) {
        return confirmPaymentWrapper(payload, true, result, undefined);
      };
      var confirmPaymentViaSDKButton = function (payload) {
        return confirmPaymentWrapper(payload, false, true, true);
      };
      var handleSdkConfirm = function ($$event) {
        var json = $$event.data;
        var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
        var payload = dict["handleSdkConfirm"];
        if (payload !== undefined) {
          confirmPaymentViaSDKButton(payload);
          return ;
        }
        
      };
      EventListenerManager$OrcaPaymentPage.addSmartEventListener("message", handleSdkConfirm, "handleSdkConfirm");
      if (isTestMode) {
        console.warn("The SDK is running in test mode. API calls are bypassed and wallet interactions are disabled.");
        console.warn("This is a non-transactional simulation environment for UI configuration and testing purposes only.");
      }
      var elements = function (elementsOptions) {
        var elementsOptionsDict = Core__JSON.Decode.object(elementsOptions);
        Core__Option.forEach(elementsOptionsDict, (function (x) {
                x["launchTime"] = Date.now();
              }));
        var sdkAuthorizationId = Utils$OrcaPaymentPage.getStringFromDict(elementsOptionsDict, "sdkAuthorization", "");
        var sdkAuthorizationData = Utils$OrcaPaymentPage.getSdkAuthorizationData(sdkAuthorizationId);
        var cs = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorizationData.clientSecret);
        var clientSecretId = cs !== undefined ? cs : Utils$OrcaPaymentPage.getStringFromDict(elementsOptionsDict, "clientSecret", "");
        var elementsOptions$1 = Core__Option.mapOr(elementsOptionsDict, elementsOptions, (function (prim) {
                return prim;
              }));
        var preloadSDKWithParams = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(elementsOptions$1), "preloadSDKWithParams");
        sdkAuthorization.contents = sdkAuthorizationId;
        clientSecret.contents = clientSecretId;
        Core__Promise.$$catch(new Promise((function (resolve, param) {
                      logger.setClientSecret(clientSecretId);
                      resolve(null);
                    })).then(function (param) {
                  logger.setLogInfo(Window$OrcaPaymentPage.hrefWithoutSearch, "ORCA_ELEMENTS_CALLED", undefined, undefined, undefined, undefined, undefined);
                  return Promise.resolve();
                }), (function (param) {
                return Promise.resolve();
              }));
        return Elements$OrcaPaymentPage.make(elementsOptions$1, setIframeRef, sessionID, publishableKey, logger, analyticsMetadata, Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Core__Option.getOr(options, null)), "customBackendUrl", ""), redirectionFlags, isTestMode, preloadSDKWithParams, isUpdateIntentInProgress, clientSecret, sdkAuthorization, paymentMethodsDataPromise, customerPaymentMethodsDataPromise, sessionTokensDataPromise);
      };
      var paymentMethodsManagementElements = function (pmManagementOptions) {
        var pmManagementOptionsDict = Core__JSON.Decode.object(pmManagementOptions);
        Core__Option.forEach(pmManagementOptionsDict, (function (x) {
                x["launchTime"] = Date.now();
              }));
        var sdkAuthorizationId = Utils$OrcaPaymentPage.getStringFromDict(pmManagementOptionsDict, "sdkAuthorization", "");
        var sdkAuthorizationData = Utils$OrcaPaymentPage.getSdkAuthorizationData(sdkAuthorizationId);
        sdkAuthorization.contents = sdkAuthorizationId;
        var pmSessionIdVal = Core__Option.getOr(sdkAuthorizationData.pmSessionId, "");
        var pmManagementOptions$1 = Core__Option.mapOr(pmManagementOptionsDict, pmManagementOptions, (function (prim) {
                return prim;
              }));
        pmSessionId.contents = pmSessionIdVal;
        Core__Promise.$$catch(new Promise((function (resolve, param) {
                      resolve(null);
                    })).then(function (param) {
                  logger.setLogInfo(Window$OrcaPaymentPage.hrefWithoutSearch, "PAYMENT_MANAGEMENT_ELEMENTS_CALLED", undefined, undefined, undefined, undefined, undefined);
                  return Promise.resolve();
                }), (function (param) {
                return Promise.resolve();
              }));
        return PaymentMethodsManagementElements$OrcaPaymentPage.make(pmManagementOptions$1, setIframeRef, pmSessionIdVal, sessionID, publishableKey, sdkAuthorizationId, logger, analyticsMetadata, Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Core__Option.getOr(options, null)), "customBackendUrl", ""));
      };
      var confirmCardPaymentFn = function (clientSecretId, data, _options) {
        var decodedData = Core__Option.getOr(Core__Option.flatMap(data, Core__JSON.Decode.object), {});
        return new Promise((function (resolve, param) {
                      iframeRef.contents.map(function (iframe) {
                            Window$OrcaPaymentPage.iframePostMessage(iframe, Object.fromEntries([
                                      [
                                        "doSubmit",
                                        true
                                      ],
                                      [
                                        "clientSecret",
                                        clientSecretId
                                      ],
                                      [
                                        "confirmParams",
                                        Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                                                "publishableKey",
                                                publishableKey
                                              ]])
                                      ]
                                    ]));
                            var handleMessage = function ($$event) {
                              var json = $$event.data;
                              var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
                              var val = dict["submitSuccessful"];
                              if (val === undefined) {
                                return resolve(json);
                              }
                              LoggerUtils$OrcaPaymentPage.logApi("CONFIRM_CARD_PAYMENT", undefined, undefined, "Method", undefined, "confirmCardPayment", val, logger, undefined, undefined, undefined);
                              var url = Utils$OrcaPaymentPage.getString(decodedData, "return_url", "/");
                              if (Core__Option.getOr(Core__JSON.Decode.bool(val), false) && url !== "/") {
                                return Utils$OrcaPaymentPage.replaceRootHref(url, redirectionFlags);
                              } else {
                                return resolve(json);
                              }
                            };
                            EventListenerManager$OrcaPaymentPage.addSmartEventListener("message", handleMessage, "");
                          });
                    }));
      };
      var addAmountToDict = function (dict, currency) {
        if (Core__Option.isNone(dict["amount"])) {
          console.error("Amount is not specified, please input an amount");
        }
        var amount = Core__Option.getOr(dict["amount"], 0.0);
        dict["amount"] = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
              [
                "currency",
                currency
              ],
              [
                "value",
                amount
              ]
            ]);
        return dict;
      };
      var paymentRequest = function (options) {
        var optionsDict = Utils$OrcaPaymentPage.getDictFromJson(options);
        var currency = Utils$OrcaPaymentPage.getJsonStringFromDict(optionsDict, "currency", "");
        var optionsTotal = Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(optionsDict["total"], Core__JSON.Decode.object), (function (x) {
                    return addAmountToDict(x, currency);
                  })), {});
        var displayItems = Utils$OrcaPaymentPage.getJsonArrayFromDict(optionsDict, "displayItems", []);
        var requestPayerName = Utils$OrcaPaymentPage.getJsonStringFromDict(optionsDict, "requestPayerName", "");
        var requestPayerEmail = Utils$OrcaPaymentPage.getJsonBoolValue(optionsDict, "requestPayerEmail", false);
        var requestPayerPhone = Utils$OrcaPaymentPage.getJsonBoolValue(optionsDict, "requestPayerPhone", false);
        var requestShipping = Utils$OrcaPaymentPage.getJsonBoolValue(optionsDict, "requestShipping", false);
        var shippingOptions = Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(optionsDict["shippingOptions"], Core__JSON.Decode.object), (function (x) {
                    return addAmountToDict(x, currency);
                  })), {});
        var applePayPaymentMethodData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
              [
                "supportedMethods",
                "https://apple.com/apple-pay"
              ],
              [
                "data",
                Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                        "version",
                        12.00
                      ]])
              ]
            ]);
        var methodData = [applePayPaymentMethodData];
        var details = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
              [
                "id",
                publishableKey
              ],
              [
                "displayItems",
                displayItems
              ],
              [
                "total",
                optionsTotal
              ],
              [
                "shippingOptions",
                shippingOptions
              ]
            ]);
        var optionsForPaymentRequest = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
              [
                "requestPayerName",
                requestPayerName
              ],
              [
                "requestPayerEmail",
                requestPayerEmail
              ],
              [
                "requestPayerPhone",
                requestPayerPhone
              ],
              [
                "requestShipping",
                requestShipping
              ],
              [
                "shippingType",
                "shipping"
              ]
            ]);
        return methodData.PaymentRequest(details, optionsForPaymentRequest);
      };
      var initPaymentSession = function (paymentSessionOptions) {
        var paymentSessionOptionsDict = Core__JSON.Decode.object(paymentSessionOptions);
        sdkAuthorization.contents = Utils$OrcaPaymentPage.getStringFromDict(paymentSessionOptionsDict, "sdkAuthorization", "");
        var sdkAuthorizationData = Utils$OrcaPaymentPage.getSdkAuthorizationData(sdkAuthorization.contents);
        var cs = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorizationData.clientSecret);
        clientSecret.contents = cs !== undefined ? cs : Utils$OrcaPaymentPage.getStringFromDict(paymentSessionOptionsDict, "clientSecret", "");
        Core__Promise.$$catch(new Promise((function (resolve, param) {
                      logger.setClientSecret(clientSecret.contents);
                      resolve(null);
                    })).then(function (param) {
                  logger.setLogInfo(Window$OrcaPaymentPage.hrefWithoutSearch, "PAYMENT_SESSION_INITIATED", undefined, undefined, undefined, undefined, undefined);
                  return Promise.resolve();
                }), (function (param) {
                return Promise.resolve();
              }));
        return PaymentSession$OrcaPaymentPage.make(paymentSessionOptions, publishableKey, sessionID, logger, redirectionFlags, iframeRef, isTestMode, isUpdateIntentInProgress, clientSecret, sdkAuthorization, paymentMethodsDataPromise, customerPaymentMethodsDataPromise, sessionTokensDataPromise);
      };
      var sessionUpdate = async function (clientSecret) {
        try {
          var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(publishableKey, undefined);
          var session = await PaymentHelpers$OrcaPaymentPage.fetchSessions(clientSecret, publishableKey, undefined, undefined, logger, undefined, endpoint, undefined, undefined, undefined);
          iframeRef.contents.forEach(function (ifR) {
                Window$OrcaPaymentPage.iframePostMessage(ifR, Object.fromEntries([[
                            "sessions",
                            session
                          ]]));
                Window$OrcaPaymentPage.iframePostMessage(ifR, Object.fromEntries([[
                            "sessionUpdate",
                            false
                          ]]));
              });
          return Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                        "updateCompleted",
                        true
                      ]]);
        }
        catch (raw_e){
          var e = Caml_js_exceptions.internalToOCamlException(raw_e);
          if (e.RE_EXN_ID === Js_exn.$$Error) {
            var errorMsg = Core__Option.getOr(e._1.message, "Something went wrong!");
            return Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                        [
                          "updateCompleted",
                          false
                        ],
                        [
                          "errorMessage",
                          errorMsg
                        ]
                      ]);
          }
          throw e;
        }
      };
      var completeUpdateIntent = function (clientSecret) {
        return sessionUpdate(clientSecret);
      };
      var initiateUpdateIntent = function () {
        iframeRef.contents.forEach(function (ifR) {
              Window$OrcaPaymentPage.iframePostMessage(ifR, Object.fromEntries([[
                          "sessionUpdate",
                          true
                        ]]));
            });
        return Promise.resolve(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                          "updateInitiated",
                          true
                        ]]));
      };
      var initAuthenticationSession = function (authenticationSessionOptions) {
        var clientSecretId = Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(Core__JSON.Decode.object(authenticationSessionOptions), (function (x) {
                        return x["clientSecret"];
                      })), Core__JSON.Decode.string), "");
        clientSecret.contents = clientSecretId;
        Core__Promise.$$catch(new Promise((function (resolve, param) {
                      logger.setClientSecret(clientSecretId);
                      resolve(null);
                    })).then(function (param) {
                  logger.setLogInfo(Window$OrcaPaymentPage.hrefWithoutSearch, "AUTHENTICATED_SESSION_INITIATED", undefined, undefined, undefined, undefined, undefined);
                  return Promise.resolve();
                }), (function (param) {
                return Promise.resolve();
              }));
        return AuthenticationSession$OrcaPaymentPage.make(authenticationSessionOptions, clientSecretId, publishableKey, logger);
      };
      var returnObject = {
        confirmOneClickPayment: confirmOneClickPayment,
        confirmPayment: confirmPayment,
        elements: elements,
        confirmCardPayment: confirmCardPaymentFn,
        retrievePaymentIntent: retrievePaymentIntentFn,
        widgets: elements,
        paymentRequest: paymentRequest,
        initPaymentSession: initPaymentSession,
        initAuthenticationSession: initAuthenticationSession,
        paymentMethodsManagementElements: paymentMethodsManagementElements,
        completeUpdateIntent: completeUpdateIntent,
        initiateUpdateIntent: initiateUpdateIntent,
        confirmTokenization: confirmPayment
      };
      window.HyperMethod = returnObject;
      return returnObject;
    }
    
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    Sentry$OrcaPaymentPage.captureException(e);
    return Types$OrcaPaymentPage.defaultHyperInstance;
  }
}

export {
  checkAndAppend ,
  preloadFile ,
  preloader ,
  handleHyperApplePayMounted ,
  make ,
}
/*  Not a pure module */
